<div class="mdc-layout-grid__cell">
  <h4 class="mdc-typography--headline4">{{ clFeature.headline }}</h4>
  <img [src]="clFeature.imagePath"
       class="img-responsive"
       style="max-width: 500px;"
       alt=""
  >
  <p class="mdc-typography--body2">{{ clFeature.body }}</p>
  <hr>
</div>
